// extracted by mini-css-extract-plugin
module.exports = {"accountVehiclesList":"AccountLoading_accountVehiclesList__HffLN","accountVehicleCard":"AccountLoading_accountVehicleCard__m0UgC"};